angular.module('powerOfAttorney', ['core', 'files', 'document'])
    .constant('PowerOfAttorneyConst', {
        eventUpdate: 'powerOfAttorney.updated',
        eventDelete: 'powerOfAttorney.deleted'
    })
    .factory('PowerOfAttorney', function ($resource) {
        return $resource('/crm/api/power-of-attorney/:id', {id: "@id"}, {
            table: {method: 'GET', isArray: false, url: '/crm/api/power-of-attorney/table'},
            tableStatistics: {method: 'GET', isArray: false, url: '/crm/api/power-of-attorney/table-statistics'},
            get: {method: 'GET'},
            update: {method: 'PUT'}
        });
    })
    .component('powerOfAttorneyStatusLabel', {
        bindings: {
            status: '<'
        },
        template: `
            <span ng-if="$ctrl.status != null" class="label label-default power-of-attorney-status {{$ctrl.status}}">{{ 'power-of-attorney.status.'.concat($ctrl.status) | translate }}</span>
        `
    })
    .service('PowerOfAttorneyService', function ($rootScope, modals, PowerOfAttorney, FilesSimpleUploadService, PowerOfAttorneyConst) {
        // this.statuses = () => ['PENDING', 'DISCUSSION', 'WAITING', 'PAUSED', 'ARCHIVED']
        this.show = id => {
            return modals.open('app/power-of-attorney/show-modal.html', 'PowerOfAttorneyShowController', {id: id}, {size: "lg"}, "$ctrl")
        }
        this.add = item => {
            let entity = {
                id: null,
                buyers: [],
                items: []
            }
            angular.extend(entity, item)
            return modals.open('app/power-of-attorney/edit-modal.html', 'PowerOfAttorneyEditController', entity, {size: "lg"}, "$ctrl")
        };
        this.edit = id => {
            let entity = {
                id: id
            }
            return modals.open('app/power-of-attorney/edit-modal.html', 'PowerOfAttorneyEditController', entity, {size: "lg"}, "$ctrl")
        };
        this.delete = item => {
            return modals.confirmDelete(item.id, () => PowerOfAttorney.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast(PowerOfAttorneyConst.eventDelete)))
        }
        this.uploadFiles = () => {
            let filters = [{
                name: 'Filtr PDF',
                fn: function(item /*{File|FileLikeObject}*/, options) {
                    var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
                    return '|pdf|'.indexOf(type) !== -1;
                }
            }]
            return FilesSimpleUploadService.open({type: 'POWER-OF-ATTORNEY', filters: filters}).then(() => $rootScope.$broadcast(PowerOfAttorneyConst.eventUpdate))
        }
    })
    .run(function (NavbarLeftMenu) {
        NavbarLeftMenu.add({
            authorities: "ROLE_POWER_OF_ATTORNEY_MODULE",
            path: "/power-of-attorney",
            ico: "fa fa-fw fa-suitcase",
            name: 'power-of-attorney.menu',
            order: 85
        });
    })
    .config(function ($stateProvider) {
        $stateProvider.state('powerOfAttorneyList', {
            parent: 'app',
            url: '/power-of-attorney?{page:int}&{size:int}&sort&search&startDate&endDate&validStart&validEnd&status&type&principal&representative&form',
            data: {
                authorities: ['ROLE_POWER_OF_ATTORNEY_MODULE']
            },
            params: {
                status: {array: true}
            },
            views: {
                'content@': 'powerOfAttorneyList'
            },
            resolve: {
                statistics: (PowerOfAttorney, $stateParams) => PowerOfAttorney.tableStatistics($stateParams).$promise,
                filters: ($stateParams) => angular.copy($stateParams),
                page: (PowerOfAttorney, $stateParams) => PowerOfAttorney.table($stateParams).$promise
            }
        })

        $stateProvider.state('powerOfAttorneyShowFull', {
            parent: 'app',
            url: '/power-of-attorney/{id}',
            data: {
                authorities: ['ROLE_POWER_OF_ATTORNEY_MODULE']
            },
            views: {
                'content@': 'powerOfAttorneyShow'
            },
            resolve: {
                item: (PowerOfAttorney, $stateParams) => PowerOfAttorney.get({id: $stateParams.id}).$promise
            }
        })
    })
